<template>
    <div :title="$translate('last_developmental_event')" class="well-last-event" :class="`${mode} ${showOverlayModal ?'':'cursor-normal'}`" @click="openOverlayModal" >
        <span class="event-label">{{ eventLabel }}</span>
        <span class="value">{{ eventName }}</span>
    </div>
</template>

<script>
import Utils from '../../../business/utils/Utils'
import UIUtils from '../../../business/utils/UIUtils'
import { mapGetters } from 'vuex'

export default {
    name: 'WellLastEvent',
    props: {
        well: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getWellIndexByWellId: 'timelapse/getWellIndexByWellId'
        }),
        eventLabel() {
            return this.$translate('event')
        },
        eventName() {
            const { morphokinetics } = this.well.inferenceData
            const lastEvent = morphokinetics[morphokinetics.length - 1]

            return this.$translate(lastEvent && lastEvent.systemName)
        },
        showOverlayModal() {
            return Utils.hasEventsForOverlayModal(this.well)
        }
    },
    methods: {
        openOverlayModal() {
            if (!this.showOverlayModal) return

            UIUtils.showModal('images_overlay', data => {
                data.well = { ...this.well, wellIndex: this.getWellIndexByWellId(this.well._id) }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.well-last-event {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10.5px;
    color: $light-3;
    border-radius: $border-radius;
    background-color: $dark-4;

    .event-label {
        color: $light;
        margin-right: 5px;
    }

    &.cursor-normal {
        cursor: auto;
    }

    &.card {
        width: 100%;
        padding: 0.25rem;
        flex-direction: row;

        &:not(.cursor-normal) {
            &:hover {
                background-color: $black;
            }
        }
    }

    &.simple {
        font-size: 10pt;
        background-color: transparent;

        .event-label {
            color: $light-3;

            &:after {
                content: ':';
            }
        }
    }
}
</style>
